var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey-results"},_vm._l((Object.entries(_vm.categories)),function([name, questions]){return _c('div',{key:name},[_c('h4',{staticClass:"survey-category-name"},[_vm._v(_vm._s(name))]),_c('SurveyCategory',{staticClass:"survey-category",attrs:{"survey":_vm.survey,"questions":questions}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }